import type { DashboardRepository } from '../../application/DashboardRepository'

/**
 * Tableau de bord en mode fixtures.
 *
 * Aucun chiffre n'est rendu : le Centre des opérations montre des indicateurs
 * d'exploitation, et un « 24 missions actives » inventé se lit comme un fait.
 * Les blocs restent absents, et l'écran le dit.
 */
export function createFixtureDashboardRepository(): DashboardRepository {
  return {
    getSnapshot() {
      return Promise.resolve({
        attention: [],
        activity: [],
        computedAt: new Date().toISOString(),
      })
    },
  }
}
